import { callTypes, DeploymentJobsSlice1 } from "./DeploymentJobsSlice";
import { successToast, warningToast } from "../../../../../../utils/ToastMessage";
import {
    addNewDeploymentJobsDetails, getAllDeployedJobsDetails,
    getAllDeploymentJobsDetails,
    getDeploymentJobDetailsById,
    startDeploymentJob,
} from "./deploymentJobs.api";

const { actions } = DeploymentJobsSlice1;

// export const fetchDeploymentJobs = (company_id) => (dispatch) => {
//   dispatch(actions.startCall({ callType: callTypes.list }));
//   return getAllDeploymentJobsDetails(company_id)
//     .then((response) => {
//         console.log("response soham",response);
//       if (response && response.isSuccess) {
//           console.log("response soham",response.data);
//           return response.data
//         // dispatch(actions.deploymentJobsFetched(response.data));
//       } else {
//         warningToast("something went wrong");
//       }
//     })
//     .catch((error) => {
//       error.clientMessage = "Can't find deployment jobs";
//       warningToast("something went wrong");
//       dispatch(actions.catchError({ error, callType: callTypes.list }));
//     });
// };


/**
 * Fetch all deployed jobs for a given company_id.
 *
 * This function sends a request to the server to get all deployed jobs for the given
 * company_id. If the request is successful, it returns a promise that resolves to an
 * array of deployed jobs. If the request fails, it returns a promise that resolves to
 * null.
 *
 * @param {String} company_id The company_id for which we want to fetch all deployed jobs.
 * @return {Promise} A promise that resolves to an array of deployed jobs, or to null if the request fails.
 */
export const fetchDeployedJobs = (company_id) => (dispatch) => {
    // Start the API call.
    dispatch(actions.startCall({ callType: callTypes.list }));

    // Send a request to get all deployed jobs for the given company_id.
    try {
        return  getAllDeployedJobsDetails(company_id).then((response) => {
            // If the request is successful, return the deployed jobs.
            if (response && response.isSuccess) {
                return response.data;
            // If the request fails, return null.
            } else {
                return null;
            }
        }).catch((error) => {
            // If there is an error, log it and dispatch an error action.
            error.clientMessage = "Can't find deployed jobs";
            console.log("error getAllDeployedJobsDetails", error);
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
    } catch (error) {
        // If there is an error, log it and dispatch an error action.
        console.log("error getAllDeployedJobsDetails", error);
        dispatch(actions.catchError({ error, callType: callTypes.list }));
    }
};

/**
 * Fetch all deployment jobs for a given company_id.
 *
 * This function dispatches an action to start the API call and then sends a request to
 * the server to get all deployment jobs for the given company_id. If the request is
 * successful, it returns a promise that resolves to an array of deployment jobs. If the
 * request fails, it returns a promise that resolves to null.
 *
 * @param {String} company_id The company_id for which we want to fetch all deployment jobs.
 * @return {Promise} A promise that resolves to an array of deployment jobs, or to null if the request fails.
 */
export const fetchDeploymentJobs = (company_id) => (dispatch) => {
    // Start the API call.
    dispatch(actions.startCall({ callType: callTypes.list }));

    // Send a request to get all deployment jobs for the given company_id.
    try {
        return  getAllDeploymentJobsDetails(company_id).then((response) => {
            // If the request is successful, return the deployment jobs.
            if (response && response.isSuccess) {
                return response.data;
            // If the request fails, return null.
            } else {
                return null;
            }
        }).catch((error) => {
            // If there is an error, log it and dispatch an error action.
            error.clientMessage = "Can't find deployment jobs";
            console.log("error getAllDeploymentJobsDetails", error);
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
    } catch (error) {
        // If there is an error, log it and dispatch an error action.
        console.log("error getAllDeploymentJobsDetails", error);
        dispatch(actions.catchError({ error, callType: callTypes.list }));
    }
};


/**
 * Creates a new deployment job with the provided data.
 *
 * This function dispatches an action to start the API call and constructs the data
 * payload from the provided deployment job data. It sends a request to add the new
 * deployment job details. If the request is successful, it dispatches an action
 * indicating the deployment job has been created and shows a success toast. Otherwise,
 * it throws an error and shows a warning toast.
 *
 * @param {Object} deploymentJobsData - The data for the deployment job.
 * @param {number} deploymentJobsData.imageSize - The size of the image.
 * @param {number} deploymentJobsData.confidenceThreshold - The confidence threshold.
 * @param {number} deploymentJobsData.iouThreshold - The IOU threshold.
 * @param {string} deploymentJobsData.modelId - The model ID.
 * @param {string} deploymentJobsData.deploymentTypeId - The deployment type ID.
 * @param {string} deploymentJobsData.status - The status of the deployment job.
 * @param {string} deploymentJobsData.userId - The ID of the user creating the job.
 * @returns {Promise} A promise that resolves when the operation is complete.
 */
export const createDeploymentJobs = (deploymentJobsData) => (dispatch) => {
  // Start the API call.
  dispatch(actions.startCall({ callType: callTypes.action }));

  // Construct the data payload from the provided deployment job data.
  const data = {
    image_size: deploymentJobsData.imageSize,
    confidence_threshold: deploymentJobsData.confidenceThreshold,
    iou_threshold: deploymentJobsData.iouThreshold,
    model_id: deploymentJobsData.modelId,
    deployment_type_id: deploymentJobsData.deploymentTypeId,
    status: deploymentJobsData.status,
    user_id: deploymentJobsData.userId,
  };

  // Request to add the new deployment job details.
  return addNewDeploymentJobsDetails(data)
    .then((response) => {
      // If the request is successful, dispatch an action with the fetched data and
      // show a success toast.
      if (response && response.isSuccess) {
        dispatch(actions.deploymentJobsCreated(response.data));
        successToast("Deployment Job Added Successfully");
      } else {
        // If the request fails, throw an error.
        throw new Error("something went wrong");
      }
    })
    .catch((error) => {
      // If the request fails, dispatch an error action and show a warning toast.
      warningToast("something went wrong");
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

/**
 * Fetches deployment job details by ID.
 *
 * This function dispatches an action to start the API call, then requests
 * deployment job details for the given ID. If the request is successful,
 * it dispatches an action with the fetched data. If the request fails,
 * it throws an error and dispatches an error action.
 *
 * @param {String} id - The ID of the deployment job to fetch.
 * @return {Promise} A promise that resolves to the deployment job details
 *                   if successful, or is rejected with an error.
 */
export const fetchDeploymentJobById = (id) => (dispatch) => {
  // Start the API call.
  dispatch(actions.startCall({ callType: callTypes.action }));

  // Request the deployment job details.
  return getDeploymentJobDetailsById(id)
    .then((response) => {
      // If the request is successful, dispatch an action with the fetched data.
      if (response && response.isSuccess) {
        dispatch(actions.deploymentJobsFetchedById(response.data));
      } else {
        // If the request fails, throw an error.
        throw new Error("Error getting deployment job details");
      }
    })
    .catch((error) => {
      // If the request fails, dispatch an error action.
      console.log("errror in fetchDeploymentJobById" , error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

/**
 * Deploys a job with the given id.
 *
 * This action will start the deployment job for the given id. The deployment job
 * will be marked as "deployed" and the deployed job details will be updated.
 *
 * @param {String} id - The ID of the deployment job to deploy.
 * @return {Promise} A promise that resolves to the deployed job if successful,
 *                   or is rejected with an error.
 */
export const startDeploymentJobById = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return startDeploymentJob(id)
    .then((response) => {
      if (response && response.isSuccess) {
        // Mark the job as deployed and update the deployed job details.
        dispatch(actions.updateDeployedJobDetails(id));
      } else {
        throw new Error("Error while deploying job");
      }
    })
    .catch((error) => {
      console.log("errror in startDeploymentJob" , error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
